import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-mat-ack-dialog',
  templateUrl: './mat-ack-dialog.component.html',
  styleUrls: ['./mat-ack-dialog.component.scss'],
  standalone: false,
})
export class MatAckDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MatAckDialogComponent>,
  ) {}

  ngOnInit() {}

  closeDialog() {
    this.dialogRef.close(false);
  }
}
